import { useContext } from "react";
import type { ReviewApi } from "@services/reviewApi";
import { ReviewApiContext } from "@services/reviewApiContext";

/** Returns the `ReviewApi` provided by `ReviewApiProvider`. */
export function useReviewApi(): ReviewApi {
  const api = useContext(ReviewApiContext);
  if (!api) {
    throw new Error("useReviewApi must be used within a ReviewApiProvider");
  }
  return api;
}
